module.exports = __webpack_public_path__ + "img/LUB00193.fa79e561.png";